import React from "react";
import { FontIcon } from "react-md";

export default function InfoButton({ onClick, color = "#EF7C01", size = 20 }) {
  return (
    <div
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color,
        marginLeft: "4px",
        width: size,
        height: size,
      }}
    >
      <FontIcon
        style={{
          fontSize: size,
          lineHeight: 1,
          color: color,
        }}
      >
        info
      </FontIcon>
    </div>
  );
}
